import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoMdHome } from "react-icons/io";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdDashboard } from "react-icons/md";

import { columnsDataCheck, columnsDataComplex } from "./variables/columnsData";

import Widget from "components/widget/Widget";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import DailyTraffic from "views/admin/default/components/DailyTraffic";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";
import UsersTable from "components/Tables/users/Users";
import { useEffect, useState } from "react";
import { API_LIST_CONTACT_US } from "api/contact-us";
import { API_GET_DASHBOARED } from "api/Dashboared-api";
import { Skeleton } from "antd";
import WidgetMulti from "components/widget/WidgetMulti";
import { lineChartOptionsTotalSpent } from "variables/charts";
import { barChartOptionsWeeklyRevenue } from "variables/charts";
import DashboaredStore from "components/Tables/Store/DashboaredStore";
import DashboaredLaundryMen from "components/Tables/LaundryMan/DashboaredLaundryMen";
import { useTranslation } from "react-i18next";
const Dashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chartOptions, setChartOptions] = useState(lineChartOptionsTotalSpent);
  const [weelyOption, setWeelyOption] = useState(barChartOptionsWeeklyRevenue);
const {t} = useTranslation();
  const fetchDataDashboared = async () => {
    try {
      setLoading(true);
      const params = {};
      const newData = await API_GET_DASHBOARED(params);
      console.log("dashboared===>", newData);
      setData(newData?.data);
      const categories = newData?.data?.monthly_categories || []; // Example: ['JAN', 'FEB', 'MAR', ...]

      // Update the xaxis categories dynamically
      setChartOptions((prevOptions) => ({
        ...prevOptions,
        xaxis: {
          ...prevOptions.xaxis,
          categories: categories,
        },
      }));
      setWeelyOption((prevOptions) => ({
        ...prevOptions,
        xaxis: {
          ...prevOptions.xaxis,
          categories: newData?.data?.weekly_categories || [],
        },
      }));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDataDashboared();
  }, []);

  return (
    <div>
      {/* Card widget */}

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-5">
        {loading ? (
          <Skeleton active />
        ) : (
          <WidgetMulti
            icon={<IoDocuments className="h-7 w-8" />}
            title={t("Revenue")}
            this_month={data?.revenue_count?.this_month || 0}
            last_month={data?.revenue_count?.last_month || 0}
            all_time={data?.revenue_count?.all_time || 0}
            change={data?.revenue_count?.change || 0}
          />
        )}

        {loading ? (
          <Skeleton active />
        ) : (
          <WidgetMulti
            icon={<MdBarChart className="h-7 w-8" />}
            title={t("Users")}
            this_month={data?.user_count?.this_month || 0}
            last_month={data?.user_count?.last_month || 0}
            all_time={data?.user_count?.all_time || 0}
            change={data?.user_count?.change || 0}
          />
        )}

        {loading ? (
          <Skeleton active />
        ) : (
          <WidgetMulti
            icon={<MdBarChart className="h-7 w-8" />}
            title={t("Drivers")}
            this_month={data?.driver_count?.this_month}
            last_month={data?.driver_count?.last_month}
            all_time={data?.driver_count?.all_time}
            change={data?.driver_count?.change}
          />
        )}

        {process.env.REACT_APP_APPLICATION_NAME === "laundry" &&
          (loading ? (
            <Skeleton active />
          ) : (
            <WidgetMulti
              icon={<MdBarChart className="h-7 w-8" />}
              title={t("Stores")}
              this_month={data?.provider_count?.this_month}
              last_month={data?.provider_count?.last_month}
              all_time={data?.provider_count?.all_time}
              change={data?.provider_count?.change}
            />
          ))}

        {loading ? (
          <Skeleton active />
        ) : (
          <WidgetMulti
            icon={<MdBarChart className="h-7 w-8" />}
            title={t("Orders")}
            this_month={data?.order_count?.this_month}
            last_month={data?.order_count?.last_month}
            all_time={data?.order_count?.all_time}
            change={data?.order_count?.change}
          />
        )}
      </div>

      {/* Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        {loading ? (
          "...."
        ) : (
          <TotalSpent monthly={data?.monthly_graph} options={chartOptions} />
        )}{" "}
        {loading ? (
          "...."
        ) : (
          <WeeklyRevenue weekly={data?.weekly_graph} options={weelyOption} />
        )}{" "}
      </div>

      {/* Tables & Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        {/* Check Table */}
        <div>
          {/* <CheckTable
            columnsData={columnsDataCheck}
            tableData={tableDataCheck}
          /> */}

          {process.env.REACT_APP_APPLICATION_NAME === "laundry" ? (
            <DashboaredStore />
          ) : (
            <DashboaredLaundryMen />
          )}
        </div>

        {/* Traffic chart & Pie Chart sasasasa*/}

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <DailyTraffic />
          <PieChartCard data={data?.pieChartData} />
        </div>

        {/* Complex Table , Task & Calendarssssnbvvvvv */}
        {/* <UsersTable /> */}
        {/* <ComplexTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        /> */}

        {/* Task chart & Calendar */}

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          {/* <TaskCard /> */}
          <div className="grid grid-cols-1 rounded-[20px]">
            {/* <MiniCalendar /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
